module.exports = __webpack_public_path__ + "static/media/LB_01.e650a00c.jpg";